<mat-card>

  <mat-card-content>
    <table mat-table matSort matSortActive="key" matSortDirection="asc" [dataSource]="dataSource" class="mat-elevation-z8">

      <ng-container matColumnDef="key">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
        <td mat-cell *matCellDef="let element" matTooltip="{{element.key}}" matTooltipPosition="above"
          matTooltipShowDelay="500"> {{element.key}} </td>
      </ng-container>

      <ng-container matColumnDef="value">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Value </th>
        <td mat-cell *matCellDef="let element" matTooltip="{{element.value}}" matTooltipPosition="above"
          matTooltipShowDelay="500"> {{ replaceSpnText(element.value) }} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row [ngClass]="getStatus(row.status)" *matRowDef="let row; columns: displayedColumns;"></tr>

    </table>
  </mat-card-content>
</mat-card>